<template>
  <div>
    <!--pc端-->
    <div class="hidden-md-and-down1">
      <nav-header
        v-bind:showSearch="p_showSearch"
        v-bind:loginModalFlag="p_loginModalFlag"
        v-on:showLoginModal="p_showLoginModal"
        v-on:closeLoginModal="p_closeLoginModal"
      ></nav-header>
      <nav-bread ref="child" @indexPCR="p_showLoginModal"></nav-bread>

      <div class="lbo" v-if="advertiseList && advertiseList.length > 0">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="item in advertiseList" :key="item.id">
            <img :src="item.picUrl" alt="" @click="toPCBanner(item)" />
          </el-carousel-item>
        </el-carousel>
        <!-- <el-carousel :interval="5000" arrow="always"> -->
        <!-- <el-carousel-item>
            <img src="../assets/xg_banner_pc.jpg" alt="检验网" style="cursor: pointer" @click="toAppoint">
          </el-carousel-item> -->
        <!-- <el-carousel-item>
            <img
              src="../assets/customs_banner_pc.png"
              alt=""
              style="cursor: pointer"
              @click="toCustom"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/breath_banner_pc.png"
              alt=""
              style="cursor: pointer"
              @click="toBreath"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/enter_banner_pc.png"
              alt=""
              style="cursor: pointer"
              @click="toEnter"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/quality_banner_pc.png"
              alt=""
              style="cursor: pointer"
              @click="toQualityApply"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="../assets/contribution_banner_pc.jpg"
              alt=""
              style="cursor: pointer"
              @click="toContribution"
            />
          </el-carousel-item> -->
        <!-- </el-carousel> -->
      </div>

      <!--<div class="container">-->
      <!--<ul class="tuitu">-->
      <!--<li>-->
      <!--<img src="../assets/advertisement_1.png" alt="" @click="toGoodsList('疫情产品',6)">-->
      <!--</li>-->
      <!--<li>-->
      <!--<img src="../assets/advertisement_2.png" alt="" @click="toGoodsList('疫情质控品',10)">-->
      <!--</li>-->
      <!--</ul>-->
      <!--</div>-->
      <div class="guding">
        <div class="Product" v-for="(item1, index1) in homelist" :key="index1">
          <div class="Produc_top">
            <div class="Produc_top_title">
              {{ item1.name }}
            </div>
            <div class="Produc_top_more">
              <el-button
                type="text"
                size="medium"
                @click="toGoodsList(item1.name, item1.id)"
                >更多&nbsp;&nbsp;></el-button
              >
            </div>
          </div>
          <div class="Produc_bottom">
            <!--<div class="Produc_bottoml">-->
            <!--<div class="qiehuan">-->
            <!--<el-carousel trigger="click" indicator-position='none' height="295px">-->
            <!--<el-carousel-item v-for="item in dataimg" :key="item">-->
            <!--<img :src="item1.adUrl" alt="">-->
            <!--</el-carousel-item>-->
            <!--</el-carousel>-->
            <!--</div>-->
            <!--</div>-->
            <div class="Produc_bottomr" @click.stop>
              <template v-if="item1.itemList.length">
                <div
                  v-for="(item2, index2) in item1.itemList"
                  :key="index2"
                  @click.stop="todetection(item2.id, item2.remark)"
                >
                  <img :src="item2.img" :alt="'检验网' + item2.itemName" />
                  <p class="title">{{ item2.itemName }}</p>
                  <p class="price">
                    ￥{{ item2.groupPrice || item2.price
                    }}<span>￥{{ item2.originalPrice }}</span>
                  </p>
                </div>
              </template>
              <template v-else>
                <p class="empty">此分类下暂无商品</p>
              </template>
            </div>
          </div>
        </div>
        <!-- <div class="Product">
          <div class="Produc_top">
            <div class="Produc_top_title">
              合作伙伴
            </div>
          </div>
          <div class="cooperative">
            <img
              src="../assets/cooperative_1.png"
              alt="检验网合作伙伴亿康基因"
            />
            <img
              src="../assets/cooperative_2.png"
              alt="检验网合作伙伴北京中同蓝博医学检验实验室有限公司"
            />
            <img
              src="../assets/cooperative_6.png"
              alt="检验网合作伙伴协力润华"
              style="max-width: 131px;"
            />
            <img
              src="../assets/cooperative_4.png"
              alt="检验网合作伙伴盾恩医学"
            />
            <img
              src="../assets/cooperative_5.png"
              alt="检验网合作伙伴之江医学检验所"
            />
          </div>
        </div> -->
      </div>
      <nav-footer></nav-footer>
    </div>

    <!--移动端-->
    <div class="hidden-md-and-up mobile">
      <!-- 优惠券悬浮按钮 -->
      <router-link to="/couponsCenter" class="mobile_conpon_btn">
        <img
          src="https://pic.jianyanwang.com/upload/20180910/333622e9808940d18a4fbfc1729e75d5.png"
        />
      </router-link>
      <!--轮播-->
      <div>
        <mt-swipe :auto="4000">
          <!--<mt-swipe-item v-for="item in advertiseList" :key="item.id">-->
          <!--<a :style="{backgroundImage:'url('+item.mobilePicUrl+')'}" @touchend.prevent="moves?toMobileBanner(item):''">-->
          <!--</a>-->
          <!--</mt-swipe-item>-->
          <!--<mt-swipe-item v-for="item in advertiseList" :key="item.id">-->
          <!--<img :src="item.picUrl" alt="">-->
          <!--</mt-swipe-item>-->
          <mt-swipe-item>
            <img
              src="../assets/hpv_banner_mobile.png"
              alt="检验网"
              style="cursor: pointer"
              @touchend.prevent="moves ? toAppoint() : ''"
            />
          </mt-swipe-item>
          <!--<mt-swipe-item>-->
          <!--<a :style="{backgroundImage:'url('+customs_banner_iphone+')'}" @touchend.prevent="moves?toCustom():''">-->
          <!--</a>-->
          <!--</mt-swipe-item>-->
          <!--<mt-swipe-item>-->
          <!--<a :style="{backgroundImage:'url('+breathe_banner_mobile+')'}" @touchend.prevent="moves?toBreath():''">-->
          <!--</a>-->
          <!--</mt-swipe-item>-->
          <!--<mt-swipe-item>-->
          <!--<a :style="{backgroundImage:'url('+enter_banner_iphone+')'}" @touchend.prevent="moves?toEnter():''">-->
          <!--</a>-->
          <!--</mt-swipe-item>-->
          <!--<mt-swipe-item>-->
          <!--<a :style="{backgroundImage:'url('+quality_banner_phone+')'}" @touchend.prevent="moves?toUrl('/service/apply/index1.html?mobile=' + user.mobile):''">-->
          <!--</a>-->
          <!--</mt-swipe-item>-->
          <!--<mt-swipe-item>-->
          <!--<a :style="{backgroundImage:'url('+contribution_banner_iphone+')'}" @touchend.prevent="moves?toUrl('/service/questionnaire/contribution/index.html?source=web'):''">-->
          <!--</a>-->
          <!--</mt-swipe-item>-->
        </mt-swipe>
      </div>
      <!--<nav-header v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag"-->
      <!--v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>-->
      <!--搜索框-->
      <div>
        <mt-search
          v-model="keywords"
          @keyup.enter.native="tomGoodsList"
        ></mt-search>
      </div>

      <!--分类类目-->
      <div class="typeBox">
        <el-row :gutter="20">
          <el-col
            :span="6"
            v-for="(item, index) in categoryList"
            :key="item.id"
          >
            <div class="type_item" @click="toGoodsList(item.name, item.id)">
              <img
                class="item_img"
                :src="item.iconUrl"
                :alt="'检验网' + item.name"
              />
              <span class="item_text">{{ item.name }}</span>
            </div>
          </el-col>
          <!--<el-col :span="6">-->
          <!--<div class="type_item" @click="toGoodsList('','')">-->
          <!--<img class="item_img" :src="allIconUrl" alt="">-->
          <!--<span class="item_text">全部</span>-->
          <!--</div>-->
          <!--</el-col>-->
        </el-row>
      </div>

      <div class="bankb">
        <div class="Product" v-for="(item1, index1) in homelist" :key="index1">
          <div class="Produc_top">
            <h3 class="Produc_top_title">
              {{ item1.name }}
            </h3>
            <div class="Produc_top_more">
              <el-button
                type="text"
                size="medium"
                @click="toGoodsList(item1.name, item1.id)"
                >更多&nbsp;&nbsp;></el-button
              >
            </div>
          </div>
          <div class="Produc_bottom">
            <div class="Produc_bottomr">
              <template v-if="item1.itemList.length">
                <div v-for="(item2, index2) in item1.itemList" :key="index2">
                  <img
                    @click="todetection(item2.id, item2.remark)"
                    :src="item2.img"
                    :alt="'检验网' + item2.itemName"
                  />
                  <p class="title">{{ item2.itemName }}</p>
                  <p class="price">
                    ￥{{ item2.groupPrice || item2.price
                    }}<span>￥{{ item2.originalPrice }}</span>
                  </p>
                </div>
              </template>
              <template v-else>
                <p class="empty">此分类下暂无商品</p>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="more_btn" @click="toGoodsList1"><a>更多</a></div>
      <div class="tip">---已经到底啦---</div>

      <!--底部导航-->
      <tabbar :selected="selected" :tabs="tabs"></tabbar>
    </div>

    <!-- SEO优化 -->
    <div class="seo_wrap">
      <h1>检验网，基因检测，医学检查</h1>
      <h2>检验网，基因检测，医学检查</h2>
      <h3>检验网，基因检测，医学检查</h3>
    </div>
  </div>
</template>

<script>
import "./../assets/css/base.css";
import "@/assets/css/product.css";
import "@/assets/css/index.css?version=1.0.1";
import { pagePath } from "../util/global";

import axios from "axios";
import Tabbar from "@/components/Tabbar.vue";
import NavHeader from "@/components/Header.vue";
import NavFooter from "@/components/Footer.vue";
import NavBread from "@/components/Bread.vue";

import { getCookie } from "../util/util";

export default {
  name: "home-page",
  metaInfo: {
    title: "检验网_基因检测检验网-专业医学检验一站式服务平台",
    meta: [
      {
        name: "keywords",
        content:
          "检验网 医学检验网 基因检验检测 新冠病毒检验检测 核酸检测 肿瘤检验检测 HPV检验检测 乳腺癌检验检测 高分子诊断"
      },
      {
        name: "description",
        content:
          "检验网是中国领先的医学检验综合服务平台,精选中国临床级基因检验检测项目和服务,轻松医检就上jianyanwang.com!"
      }
    ]
  },
  data() {
    return {
      apiPath: pagePath,
      advertiseList: [],
      categoryList: [],
      itemHotList: [],
      homelist: [],
      selected: "HomePage",
      tabs: [
        require("@/assets/hose_Filled.png"),
        require("@/assets/shopping_grey.png"),
        require("@/assets/me_grey.png")
      ],
      allIconUrl:
        "https://pic.jianyanwang.com/upload/20181219/3bf0e72657874c82af7e4d45551765e7.png",
      p_showSearch: true,
      p_loginModalFlag: false,
      hasMoreData: true,
      dataimg: [
        {
          src: require("../assets/2.jpg")
        },
        {
          src: require("../assets/22.jpg")
        }
      ],
      isFixed: false,
      offsetTop: 0,
      step: 0,
      tabIdx: [0, 0, 0, 0, 0],
      offsetLeft: "",
      keywords: "",
      moves: true,
      breathe_banner_mobile: require("@/assets/breathe_banner_mobile.png"),
      quality_banner_phone: require("@/assets/quality_banner_phone.png"),
      contribution_banner_iphone: require("@/assets/contribution_banner_iphone.jpg"),
      customs_banner_iphone: require("@/assets/customs_banner_iphone.png"),
      enter_banner_iphone: require("@/assets/enter_banner_iphone.png"),
      appoint_banner_iphone: require("@/assets/appoint_banner_iphone.png")
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  components: {
    Tabbar,
    NavHeader,
    NavFooter,
    NavBread
  },
  mounted() {
    let that = this;
    window.addEventListener("touchmove", function() {
      that.moves = false;
      window.addEventListener("touchend", function() {
        that.moves = true;
      });
    });

    this.getAdList();
    this.getCategoryList();
    this.getHotList();

    // this.$refs.child.show = true;
    this.$store.commit("updateProviderId", "");
    localStorage.setItem("providerId", "");
  },
  methods: {
    p_showLoginModal() {
      this.p_loginModalFlag = true;
    },
    toGoodsList1() {
      window.scroll(0, 0);
      this.$router.push("/goodsList");
    },
    p_closeLoginModal() {
      this.p_loginModalFlag = false;
    },

    toSearch(itemName, id) {
      this.$router.push({
        path: "search",
        query: {
          id: id,
          name: itemName
        }
      });
    },

    toGoodsList(itemName, id) {
      this.$router.push({
        path: "/goodsList",
        query: {
          id: id,
          name: itemName
        }
      });
    },
    tomGoodsList() {
      this.$router.push({
        path: "/goodsList",
        query: { params: this.keywords }
      });
    },

    //获取广告
    getAdList() {
      axios
        .get("/jys/ad/list", {
          params: {
            platform: "1"
          }
        })
        .then(res => {
          this.advertiseList = res.data.list.filter(item => {
            if (!item.link) return false;
            let link = JSON.parse(item.link);
            return link.linkType === "1";
          });
        });
    },

    //获取类目列表
    getCategoryList() {
      axios
        .get("/jys/category?shopId=" + this.$store.state.providerId)
        .then(res => {
          if (res.data.code === 0) {
            this.categoryList = res.data.list;
            this.homelist = [];
            for (let i = 0; i < res.data.list.length; i++) {
              let item = res.data.list[i];
              let temp = {
                itemList: [],
                ...item
              };
              axios.get("/jys/item/category/" + item.id).then(res => {
                if (res.data.code === 0) {
                  temp.itemList = res.data.itemList.slice(0, 6);
                  this.homelist.push(temp);
                  this.homelist = this.homelist.sort(this.sortData);
                }
              });
            }
          }
        });
    },
    //分类排序
    sortData(a, b) {
      return a.sortNum - b.sortNum;
    },

    //获取热门商品列表
    getHotList() {
      axios
        .get("/jys/item/hot", {
          headers: {
            "Content-Type": "application/json",
            token: getCookie("_token") ? getCookie("_token") : ""
          }
        })
        .then(res => {
          this.hasMoreData = false;
          this.itemHotList = res.data.itemHotList;
        });
    },

    //跳转到详情页
    todetection(id, remark) {
      let { href } = this.$router.resolve({
        path: "detection",
        query: {
          id: id,
          remark: remark
        }
      });
      window.open(href, "_blank");
    },

    // banner跳转详情
    toPCBanner(item) {
      let link = JSON.parse(item.link);
      link.link.toLowerCase().indexOf("http") >= 0
        ? window.open(link.link)
        : this.$router.push(link.link);
    },

    toMobileBanner(item) {
      let link = JSON.parse(item.link);
      if (link.mobileLinkType) {
        link.mobileLinkType === "1"
          ? this.$router.push({ path: link.mobileLink })
          : (window.location.href = this.apiPath + link.mobileLink);
      } else {
        link.linkType === "1"
          ? this.$router.push({ path: link.link })
          : (window.location.href = this.apiPath + link.link);
      }
    },

    //申请页跳转
    toQualityApply() {
      this.$router.push("/qualityApply");
    },

    //捐献页跳转
    toContribution() {
      window.location.href =
        this.apiPath +
        "/service/questionnaire/contribution/index.html?source=web";
    },

    // 呼吸道病原体检测
    toBreath() {
      this.$router.push({ path: "/NovelCoronavirusSample" });
    },

    toUrl(url) {
      window.location.href = this.apiPath + url;
    },

    toCustom() {
      this.$router.push({ path: "/NovelCoronavirusCustoms" });
    },

    toEnter() {
      this.$router.push({ path: "/NovelCoronavirusEnter" });
    },

    toAppoint() {
      this.$router.push({
        path: "/goodsList",
        query: {
          id: 6,
          name: "新冠检测"
        }
      });
    }
  }
};
</script>

<style scoped>
.seo_wrap {
  position: absolute;
  left: -999px;
}

/deep/ .navbar-left-container .home {
  display: none !important;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.goods .goUl {
  width: 100%;
}

.mr_30 {
  margin-right: 30px;
}

.titName {
  background: #00c5b0;
  color: #fff;
  width: 100%;
}

.text {
  margin-left: 10px;
}

.goodName {
  font-size: 18px;
  color: #fff;
  margin-left: 30px;
}

.mygoods {
  width: 100%;
  margin: 0 auto;
}

.allGood {
  width: 100%;
  background: #fff;
}

.louc0,
.louc1,
.louc2,
.louc3,
.louc4 {
  width: 237px;
  height: 22px;
  padding-left: 50px;
}

.louc0 {
  background: url(../assets/1f.png) no-repeat;
}

.louc1 {
  background: url(../assets/2f.png) no-repeat;
}

.louc2 {
  background: url(../assets/3f.png) no-repeat;
}

.louc3 {
  background: url(../assets/4f.png) no-repeat;
}

.louc4 {
  background: url(../assets/5f.png) no-repeat;
}

.icon_tit {
  width: 30px;
  height: 30px;
  margin-top: 15px;
  margin-left: 30px;
}

.good_title {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fff;
  margin: 0 auto;
  /*margin-top:20px;*/
}

.goodicon {
  width: 30px;
  height: 30px;
  margin-top: 6px;
}

.lubPic {
  width: 100%;
  height: 320px;
}

.lubMain {
  position: relative;
  width: 100%;
  height: 320px;
}

.lub {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 320px;
}

.goods {
  width: 24%;
  height: 371px;
  background: #fff;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  border-bottom: 2px solid #00c5b0;
}

.el-carousel__container {
  position: relative;
  height: 395px;
}

.goods ul {
  width: 80%;
  margin: 0 auto;
}

.goods ul li {
  width: 100%;
  height: 53px;
  line-height: 53px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.goods ul li:last-child {
  border-bottom: none;
}

.nav-breadcrumb a {
  color: #00c5b0;
}

.nav-breadcrumb .allgoods {
  color: #999;
}

.load-more {
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.sort-up {
  transform: rotate(180deg);
  transtion: all 0.5s ease-out;
}

.banner {
  width: 100%;
  margin: 0 auto;
}

.catePic {
  display: inline-block;
  text-align: center;
}

.myCate {
  display: block;
  text-align: center;
  padding: 10px 0;
}

.container {
  width: 100%;
  padding: 0;
}

.tuitu {
  display: flex;
  width: 70%;
  margin: 30px auto;
  overflow: hidden;
  justify-content: space-between;
}

.tuitu li {
  width: 45%;
  margin-right: 1px;
}

.tuitu img {
  width: 100%;
  height: 200px;
  display: block;
  cursor: pointer;
}

.Product {
  margin: 10px auto 40px;
  position: relative;
}

.Produc_top {
  width: 100%;
  float: left;
  height: 35px;
  line-height: 35px;
  margin: 15px 0;
}

.Produc_top img {
  margin-right: 10px;
  vertical-align: middle;
}

.Produc_top_title {
  width: 50%;
  float: left;
  padding-left: 10px;
  border-left: 6px solid #00c5b0;
  font-size: 16px;
  font-weight: bolder;
}

.Produc_top_more {
  width: 50%;
  float: right;
  text-align: right;
}

.cooperative {
  width: 100%;
  float: left;
  margin: 20px 0;
}

.cooperative img {
  width: 16%;
  height: 55px;
  margin-right: 3%;
}

.Produc_topl {
  font-size: 16px;
  color: #4a4a4a;
}

.Produc_topr li {
  float: left;
  padding: 0 10px;
  border-right: 1px solid #ccc;
}

.Produc_topr li:last-child {
  border-right: none;
}

.Produc_topr li a {
  border-radius: 5px;
  padding: 0 5px;
  position: relative;
}

.Produc_topr li a.on,
.Produc_topr li a:hover {
  background: #00c5b0;
  color: #fff;
}

.Produc_topr li a::before {
  background: #00c5b0;
  width: 10px;
  height: 10px;
  position: absolute;
  bottom: -4px;
  left: 43%;
  content: "";
  z-index: -1;
  transform: rotate(45deg);
  display: none;
}

.Produc_topr li a:hover:before,
.Produc_topr li a.on:before {
  display: block;
}

.Produc_bottom {
  width: 100%;
  float: left;
}

.Produc_bottoml {
  width: 214px;
  float: left;
}

.qiehuan {
  width: 100%;
  position: relative;
}

.qiehuan img {
  width: 100%;
  height: 200px;
  display: block;
}

.Produc_bottomlist li,
.Produc_bottomlist li img {
  width: 107px;
  height: 107px;
}

.Produc_bottomlist li {
  float: left;
}

.Produc_bottomr {
  /*width: calc(100% - 214px);*/
  width: 100%;
  float: left;
}

.Produc_bottomr > div {
  float: left;
  width: 178px;
  margin: 10px 20px 12px 18px;
  cursor: pointer;
}

.Produc_bottomr > div:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out;
  transform: translateY(-5px);
}

.Produc_bottomr img {
  display: block;
  width: 176px;
  height: 176px;
}

.Produc_bottomr p.title {
  color: #000;
  font-size: 11px;
  line-height: 30px;
  overflow: hidden;
  width: 168px;
  padding-left: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.Produc_bottomr p.price {
  color: red;
  padding: 0 0 5px 10px;
  width: 168px;
  font-size: 12px;
  overflow: hidden;
}

.Produc_bottomr p.price span {
  color: #999;
  text-decoration: line-through;
  padding-left: 10px;
  font-size: 12px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.el-carousel {
  overflow: hidden;
}

.lbo img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/deep/ .el-carousel__container {
  height: 370px;
}

.guding {
  width: 70%;
  margin: 0 auto;
  position: relative;
}

.fmanu {
  border: 1px solid #ddd;
  position: absolute;

  top: 0;
  z-index: 99;
  background: #fff;
  left: -60px;
}

.fmanu li {
  color: #999;
  height: 80px;
  width: 50px;
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fmanu li:last-child {
  border-bottom: none;
}

.fmanu li:hover,
.fmanu li.on {
  background: #00c5b0;
  color: #fff;
}

.fixedBar {
  position: fixed;
  top: 0;
  left: 140px;
}

/deep/ .cont {
  background-color: #fff !important;
}

.more_btn {
  width: 100%;
  float: left;
  text-align: center;
  padding: 25px 0;
}
.more_btn a {
  display: block;
  padding: 5px 0;
  margin: 0 auto;
  width: 200px;
  color: #fff;
  background-color: #00c5b0;
  border-radius: 20px;
}
/deep/ .mint-swipe-items-wrap a {
  display: block;
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: scroll;
  z-index: 9999;
}
/deep/ .el-carousel__arrow {
  z-index: 10000000;
}
.empty {
  width: 100%;
  line-height: 40px;
}
@media only screen and (min-width: 320px) and (max-width: 992px) {
  .mobile_conpon_btn {
    position: fixed;
    bottom: 10%;
    right: 5%;
    width: 70px;
    height: 70px;
    z-index: 1;
  }

  .mobile_conpon_btn img {
    width: 100%;
    height: 100%;
  }

  /deep/ .navbar2 {
    display: none;
  }

  /deep/ .navbar {
    top: 17px !important;
  }

  /deep/ .header {
    height: 40px;
  }

  /deep/ .md-modal {
    margin-top: -194px !important;
  }

  .el-col-6 {
    width: 20%;
  }

  .Product {
    margin: 8px 10px 10px 10px;
  }

  .Produc_top ul {
    display: flex;
    justify-content: flex-end;
  }

  .Produc_bottomr {
    width: 100%;
    float: left;
  }

  .Produc_bottomr > div {
    width: 170px;
    margin: 10px 5px;
  }

  .Produc_bottomr img {
    width: 170px;
    height: 170px;
  }

  .mobile .goods_item .item_desc {
    width: 200px;
  }

  .Produc_topr li {
    border-right: none;
  }

  .Produc_topr li a {
    font-size: 13px;
    color: #03dac4;
    margin-bottom: 10px;
  }

  .Produc_topr li a:hover {
    background: none;
    color: #03dac4;
  }

  .bankb {
    background: url(../assets/bg.jpg) repeat-x;
    padding-top: 2px;
  }

  .Produc_top {
    justify-content: space-between;
  }

  /deep/ .navbar-left-container .home {
    display: none !important;
  }
}

@media only screen and (min-width: 320px) and (max-width: 375px) {
  .Produc_bottomr {
    padding: 0;
  }

  .Produc_bottomr > div {
    margin: 10px 2px;
  }

  /deep/ .navbar-left-container .home {
    display: none !important;
  }
}

@media only screen and (min-width: 320px) and (max-width: 360px) {
  .Produc_bottomr {
    padding: 0;
  }

  .Produc_bottomr > div {
    width: 160px;
    margin: 10px 5px;
  }

  .Produc_bottomr img {
    width: 160px;
    height: 170px;
  }

  /deep/ .navbar-left-container .home {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  .hidden-md-and-down1 {
    display: none !important;
  }

  /deep/ .navbar-left-container .home {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/HomePage_Quality.vue